import { api } from "./config";

export async function ClientSetPassword(password = "") {
  try {
    const responseData = await api()
      .post("/client/set-password", {
        password,
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}
export async function ClientGetMyAccountInfo() {
  try {
    const responseData = await api()
      .get("/client/my-account")
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}
export async function ClientGetMyPackage(page, pageSize, sort, search, status) {
  console.log("🚀 ~ ClientGetMyPackage ~ status:", status);
  try {
    const responseData = await api()
      .get("/client/my-package", {
        params: {
          page,
          pageSize,
          sort: JSON.stringify(sort),
          search,
          status,
        },
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}
export async function ClientGetCountPackagesByStatus() {
  try {
    const responseData = await api()
      .get("/client/count-packages-by-status")
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientGetRouteList() {
  try {
    const responseData = await api()
      .get("/client/route-list")
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientStorePackage(tracking, routeId, orderId, description, remark) {
  try {
    const responseData = await api()
      .post("/client/store-package", {
        tracking,
        routeId,
        orderId,
        description,
        remark,
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}


export async function ClientGetStationDetailById(id) {
  try {
    const response = await api().get("client/station", {
      params: {
        id: id,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function ClientGetStationList() {
  try {
    const response = await api().get("client/stations");
    return response.data;
  } catch (error) {
    console.error(error);
    return { success: false, data: [] };
  }
}

export async function ClientStoreTrackingLog(
  packageId,
  tracking,
  station,
  description,
  remark,
  actionByUser,
  validflag = true
) {
  try {
    const response = await api()
      .post("/client/store-trackinglog", {
        packageId,
        tracking,
        station,
        description,
        remark,
        actionByUser,
        validflag,
      })
      .then((res) => res.data)
      .catch((error) => error.response);
    return response;
  } catch (error) {
    console.log(error);
  }
}
export async function ClientUpdatePassword(oldPassword, newPassword) {
  try {
    const responseData = await api()
      .post("/client/update-password", {
        oldPassword,
        newPassword,
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientUpdateProfile(name, default_route, isDeliveryRequired, deliveryAddresses, isForwardRequired, forwardAddresses) {
  try {
    const responseData = await api()
      .patch("/client/update-profile", {
        name,
        default_route,
        isDeliveryRequired,
        deliveryAddresses,
        isForwardRequired,
        forwardAddresses
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientUpdateWhatsAppNumber(currentPassword, newWhatsApp, otp, ref) {
  try {
    const responseData = await api()
      .post("/client/update-whatsapp", {
        currentPassword,
        newWhatsApp,
        otp,
        ref
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientCheckWhatsappExists(phoneNumber) {
  try {
    const responseData = await api()
      .post("/client/check-whatsapp-update", { whatsapp: phoneNumber })
      .then((res) => res.data)
      .catch((error) => error.response?.data || { error: true, message: error.message });
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientRequestWhatsAppOTP(phoneNumber, ref) {
  try {
    const response = await api()
      .post("/public/otp-request", {
        phone: phoneNumber,
        ref: ref,
        otpType: "whatsapp-update"
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientGetLatestExchangeRates() {
  try {
    const responseData = await api()
      .get("/client/exchange-rate/latest")
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientUploadProfilePicture(file) {
  try {
    const formData = new FormData();
    formData.append('profilePicture', file);
    
    const responseData = await api()
      .post("/client/upload-profile-picture", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientDeleteProfilePicture() {
  try {
    const responseData = await api()
      .delete("/client/profile-picture")
      .then((res) => res.data)
      .catch(
        (error) =>
          error.response?.data || { error: true, message: error.message }
      );
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientUploadDeliveryAddressPhoto(file) {
  try {
    const formData = new FormData();
    formData.append('photo', file);
    const responseData = await api()
      .post("/client/delivery-address-photo", formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => error.response?.data || { error: true, message: error.message });
    return responseData;
  } catch (error) {
    console.log(error);
  }
}

export async function ClientDeleteDeliveryAddressPhoto(filename) {
  try {
    const responseData = await api()
      .delete(`/client/delivery-address-photo/${encodeURIComponent(filename)}`)
      .then((res) => res.data)
      .catch((error) => error.response?.data || { error: true, message: error.message });
    return responseData;
  } catch (error) {
    console.log(error);
  }
}